<template>
  <div>
    <div class="climbing-table__title">
      <h2>{{ title }}</h2>
    </div>
    <div class="climbing-table__wrap">
      <div class="climbing-table__wrap-price">
        <div data-simplebar="data-simplebar" class="climbing-table__section-wrap">
          <table class="climbing-table js-table-column-hover">
            <thead>
            <tr>
              <th class="default-table__th default-table__th-title"><span>Program</span></th>
              <th class="default-table__th"><span>1 Pax</span></th>
              <th class="default-table__th"><span>2 Pax</span></th>
              <th class="default-table__th"><span>3 Pax</span></th>
              <th class="default-table__th"><span>4 Pax</span></th>
              <th class="default-table__th"><span>5 Pax</span></th>
              <th class="default-table__th"><span>6 Pax</span></th>
              <th class="default-table__th"><span>7 Pax</span></th>
              <th class="default-table__th"><span>8 Pax</span></th>
              <th class="default-table__th"><span></span></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in innerCosts" :key="item.routeId">
              <td class="default-table__th-title">
                <span>{{ item.routeName }} {{ item.duration }} Days</span>
              </td>
              <td class="default-table__td" @click="handleEdit">
                <div class="climbing-table__td-wrapper">
                  <span v-if="item.pax1">$</span>
                  <input type="text" v-mask="'######'" v-model="item.pax1">
                </div>
              </td>
              <td @click="handleEdit">
                <div class="climbing-table__td-wrapper">
                  <span v-if="item.pax2">$</span>
                  <input type="text" v-mask="'######'" v-model="item.pax2">
                </div>
              </td>
              <td @click="handleEdit">
                <div class="climbing-table__td-wrapper">
                  <span v-if="item.pax3">$</span>
                  <input type="text" v-mask="'######'" v-model="item.pax3">
                </div>
              </td>
              <td @click="handleEdit">
                <div class="climbing-table__td-wrapper">
                  <span v-if="item.pax4">$</span>
                  <input type="text" v-mask="'######'" v-model="item.pax4">
                </div>
              </td>
              <td @click="handleEdit">
                <div class="climbing-table__td-wrapper">
                  <span v-if="item.pax5">$</span>
                  <input type="text" v-mask="'######'" v-model="item.pax5">
                </div>
              </td>
              <td @click="handleEdit">
                <div class="climbing-table__td-wrapper">
                  <span v-if="item.pax6">$</span>
                  <input type="text" v-mask="'######'" v-model="item.pax6">
                </div>
              </td>
              <td @click="handleEdit">
                <div class="climbing-table__td-wrapper">
                  <span v-if="item.pax7">$</span>
                  <input type="text" v-mask="'######'" v-model="item.pax7">
                </div>
              </td>
              <td @click="handleEdit">
                <div class="climbing-table__td-wrapper">
                  <span v-if="item.pax8">$</span>
                  <input type="text" v-mask="'######'" v-model="item.pax8">
                </div>
              </td>
              <td>
                <div>
                  <svg width="25" height="25" class="icon icon-price-change"
                       @click="
                          editPopup = true;
                          inputTitle = `${item.routeName} ${item.duration} Days`;
                          editingRowNumber = index
                  ">
                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-price-change"></use>
                </svg>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="climbing-table__save-btn">
        <button type="button" class="btn btn--green" @click="handleUpdate"><span>Save</span>
        </button>
      </div>
    </div>
    <div class="modal-wrapper" v-if="editPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--notes">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon edit-popup__title__icon--mod">
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="10.5" cy="10.5" r="10.5" fill="#77B017"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 18C14.6421 18 18 14.6421 18 10.5C18 6.35787 14.6421 3 10.5 3C6.35787 3 3 6.35787 3 10.5C3 14.6421 6.35787 18 10.5 18ZM11.1818 6.40909C11.1818 6.03254 10.8766 5.72727 10.5 5.72727C10.1234 5.72727 9.81818 6.03254 9.81818 6.40909V6.80831C8.85597 7.03089 8.11364 7.86697 8.11364 8.90508C8.11364 9.93832 8.86016 10.8012 9.86202 11.0116L10.8113 11.2109C11.2456 11.3022 11.5227 11.6602 11.5227 12.0382C11.5227 12.4807 11.141 12.8864 10.6109 12.8864H10.5C10.0049 12.8864 9.61466 12.5631 9.50768 12.1643C9.41018 11.8006 9.0363 11.5848 8.67259 11.6823C8.30888 11.7798 8.09308 12.1537 8.19059 12.5175C8.40353 13.3117 9.03028 13.9257 9.81818 14.1537V14.5909C9.81818 14.9675 10.1234 15.2727 10.5 15.2727C10.8766 15.2727 11.1818 14.9675 11.1818 14.5909V14.1792C12.1479 13.9353 12.8864 13.0868 12.8864 12.0382C12.8864 10.9784 12.1205 10.0925 11.0915 9.87641L10.1423 9.67705C9.73507 9.59155 9.47727 9.2565 9.47727 8.90508C9.47727 8.49395 9.83257 8.11364 10.3301 8.11364H10.5C10.9951 8.11364 11.3853 8.43687 11.4923 8.83565C11.5898 9.19936 11.9637 9.41516 12.3274 9.31766C12.6911 9.22016 12.9069 8.84624 12.8094 8.48253C12.5965 7.68832 11.9697 7.0743 11.1818 6.84627V6.40909Z" fill="white"/>
                </svg>
              </div>
              <span>Cost for {{ inputTitle }} </span>
            </div>
            <div class="edit-popup__close" @click="editPopup = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <div class="edit-popup--choose-hotel__form">
            <div class="climbing-edit">
              <div class="climbing-edit__text">Type the costs with a comma in between, start with 1 pax</div>
              <div class="climbing-edit__input-wrapper" :class="{'climbing-edit__input-wrapper--error': isError}">
                <BasicInput type="text" v-model="input" placeholder="123, 456, 789 ..."/>
              </div>
            </div>

            <div class="edit-popup--choose-hotel__submit">
              <button
                  type="submit"
                  class="btn btn--green"
                  @click.prevent="
                  () => {
                    updateRow()
                  }
                ">
                <span>Save</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {TheMask} from 'vue-the-mask'
import BasicInput from "@/components/UI/Inputs/BasicInput.vue";
export default {
  name: "ClimbingPricesTable",
  components: {BasicInput, TheMask},
  props: ['costs', 'title'],
  data() {
    return {
      editPopup: false,
      input: '',
      inputTitle: '',
      editingRowNumber: 0,
      isError: false,
      innerCosts: structuredClone(this.costs)
    }
  },
  watch: {
    costs: {
      handler(newValue, oldValue){
        this.innerCosts = structuredClone(newValue);
      },
      deep: true
    }
  },
  methods: {
    handleUpdate() {
      this.$emit('update', this.innerCosts);
    },
    handleEdit() {
      this.$emit('edit', true);
    },
    parseInput(input) {
      return input.split(',').map(item => item.trim()).filter(item => !isNaN(item));
    },
    validateRow(input) {
      const isValid = this.parseInput(input).length === 8
      if (!isValid) {
        this.isError = true;
      } else {
        this.isError = false;
      }
      return isValid;
    },
    updateRow() {
      if (this.validateRow(this.input)) {
        const parsedValues = this.parseInput(this.input);
        this.innerCosts[this.editingRowNumber]['pax1'] = parsedValues[0];
        this.innerCosts[this.editingRowNumber]['pax2'] = parsedValues[1];
        this.innerCosts[this.editingRowNumber]['pax3'] = parsedValues[2];
        this.innerCosts[this.editingRowNumber]['pax4'] = parsedValues[3];
        this.innerCosts[this.editingRowNumber]['pax5'] = parsedValues[4];
        this.innerCosts[this.editingRowNumber]['pax6'] = parsedValues[5];
        this.innerCosts[this.editingRowNumber]['pax7'] = parsedValues[6];
        this.innerCosts[this.editingRowNumber]['pax8'] = parsedValues[7];

        this.editPopup = false;
        this.input = '';
        this.$emit('changeRow', this.innerCosts)
      }
    }
  },
}
</script>

<style scoped lang="scss">
.climbing {
  &-edit {
    display: flex;
    flex-direction: column;

    &__text {
      font-size: 12px;
      font-weight: 500;
    }

    &__input-wrapper {
      margin-top: 10px;

      &--error {
        border: 2px solid #F49898;
        border-radius: 5px;
      }
    }
  }

  &-table {
    width: 100%;
    min-width: 87.9rem;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #1a1a1a;
    margin-bottom: 15px;
    overflow: hidden;

    &__save-btn {
      margin-top: 1.2rem;
      margin-right: 1.2rem;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: end;
      -webkit-justify-content: flex-end;
      -ms-flex-pack: end;
      justify-content: flex-end;
    }

    &__td-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    th, td {
      padding: 9px 8px 8px;
      border: 1px solid #e3e3e3;
    }

    th {
      font-weight: 500;
      border-bottom: 0;
    }

    tbody td input {
      width: 50px;
      border: none;
      outline: none;
      background-color: transparent;
    }
    tbody td, tbody th {
      border-bottom-width: 0;
      -webkit-transition: border-color 0.3s ease;
      -o-transition: border-color 0.3s ease;
      transition: border-color 0.3s ease;
      position: relative;
    }

    tbody td:before, tbody th:before {
      content: '';
      display: block;
      top: -1px;
      left: -1px;
      right: -1px;
      bottom: -1px;
      position: absolute;
    }

    tbody td.hovered:before, tbody th.hovered:before {
      background: rgba(160, 231, 41, 0.2);
    }

    tbody td:before {
      display: none;
    }

    tbody tr:nth-child(even) td,
    tbody tr:nth-child(even) th {
      background: #f5f5f5;
    }

    tbody tr:last-child td {
      border-bottom-width: 1px;
    }

    tbody tr:hover td {
      border-top-color: #8e8e8e;
    }

    tbody tr:hover + tr td {
      border-top-color: #8e8e8e;
    }

    tbody tr:hover:last-child td {
      border-bottom-color: #8e8e8e;
    }

    tbody tr:hover td:first-child {
      border-left-color: #8e8e8e;
    }

    tbody tr:hover td:last-child {
      border-right-color: #8e8e8e;
    }

    thead th {
      background: #f6f6f6;
      border-color: #f6f6f6;
      border-bottom-color: #e3e3e3;
      padding-top: 8px;
      padding-bottom: 8px;
    }

    thead th:first-child {
      -webkit-border-top-left-radius: 3px;
      border-top-left-radius: 3px;
    }

    thead th:last-child {
      -webkit-border-top-right-radius: 3px;
      border-top-right-radius: 3px;
    }

    .default-table__th-title:before {
      display: none;
    }

    &__title {
      margin: 25px 0 15px 0;
    }
    &__wrap {
      background: #fff;
      padding-bottom: 21px;
      -webkit-box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.15);
      box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.15);
      -webkit-border-radius: 5px;
      border-radius: 5px;

      &-price {
        overflow: hidden;
      }
    }
    &__section {
      &-wrap {
        min-height: 90px;
        overflow-x: auto;
      }
    }
  }
}
.icon-price-change {
  cursor: pointer;
  font-size: 25px;
}
</style>